<template>
  <div class="selectPersonBox">
    <div class="searchDiaBox">
      <el-select v-model="sourceInit1" placeholder="请选择" size="mini" @change="changeSource">
        <el-option v-for="item in orgOptions" :key="item.id" :label="item.name" :value="item.code"></el-option>
      </el-select>
      <el-input style="width: 200px;margin-left: 20px;" size="mini" placeholder="输入关键字或手机号" suffix-icon="el-icon-search"
        v-model="searchPerson" @change="changeSearchHandle" @clear="searchLatestPersonFun" @input="handleInput"
        clearable></el-input>
    </div>
    <div class="normalPerson">
      <div class="operateBox">
        <!--         <span>最近联系人</span> -->
        <span class="bloder" v-show="isLatestPerson">常用联系人</span>
        <span class="clearNormal" @click="clearAllPer">清空常用联系人</span>
      </div>
      <div class="personSelect" v-loading="loading">
        <div style="margin-bottom: 15px;" v-if="!radio">
          <el-checkbox v-model="checkedAll" @change="selectAllFun">全选</el-checkbox>
        </div>
        <div v-if="!radio" class="normalPersons">
          <div class="personCard" v-for="(item, index) in normalPersonList" :key="index">
            <select-card :key="'tab1' + index" :itemData="item" :title="computedTitle(item)"
              :selectedList="selectedList" v-bind="$attrs" v-on="$listeners"></select-card>
          </div>
        </div>
        <div v-if="radio" class="normalPersons">
          <div class="personCard" v-for="(item, index) in normalPersonList" :key="index">
            <select-radio-card :key="'tab1' + index" :itemData="item" :title="computedTitle(item)"
              :selectedList="selectedList" v-bind="$attrs" v-on="$listeners"></select-radio-card>
          </div>
        </div>
      </div>
      <div>
        <el-pagination class="person-page" :disabled="paginationDisabled" @size-change="handleSizeChange"
          @current-change="searchPersonFun(searchPerson)" :current-page.sync="searchForm.current"
          :page-sizes="$config.paginationPages" :page-size="searchForm.size" :pager-count="5" small
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import selectCard from './selectCard';
import selectRadioCard from './selectRadioCard';

export default {
  props: {
    selectedList: {
      type: Array,
      default: () => []
    },
    onlyPeople: {
      type: Boolean,
      default: false
    },
    sourceInit: {
      type: String,
      default: 'PS'
    },
    orgOptions: {
      type: Array,
      default: () => []
    },
    radio: {
      type: Boolean,
      default: false
    },
  },
  components: {
    selectCard: selectCard,
    selectRadioCard
  },
  created() {
    // this.initNormal()
    this.searchLatestPersonFun();
    this.isLatestPerson = true;
    this.sourceInit1 = this.sourceInit;
  },
  data() {
    return {
      searchPhone: '',
      searchPerson: '',
      checkedAll: false,
      normalPersonList: [],
      sourceInit1: '',
      searchForm: {
        current: 1,
        size: 10
      },
      total: 0,
      paginationDisabled: false,
      isLatestPerson: true,
      loading: false
    };
  },
  methods: {
    changeSource() {
      this.changeSearchHandle();
    },
    computedTitle(item) {
      if (item.pathName) {
        if (item.pathName) {
          return item.user.name + ' (' + item.user.pathName + ')';
        }
      } else {
        return item.user.name;
      }
    },
    isCheked(item) {
      let sign = false;
      this.selectedList.map(inside => {
        if (item.user.userId == inside.user.userId) {
          sign = true;
        }
      });
      return sign;
    },
    searchPersonFun(val) {
      if (this.paginationDisabled) {
        this.searchForm.size = 10;
      }
      if (val) {
        let obj = {
          type: 1,
          source: this.sourceInit1,
          enable: 1,
          dataInfo: 'userInfo,userJob,userPersonnel',
          ...this.searchForm
        };
        if (/^[\u4E00-\u9FA5]{1,5}$/.test(val)) {
          obj.name = val;
        }
        else if (/^1[3-9]\d{9}$/.test(val)) {
          obj.phone = val;
        }
        else {
          obj.userName = val;
        }
        this.loading = true;
        this.$axios
          .get('/uc/user/page', obj)
          .then(res => {
            if (res.body.records.length !== 0) {
              this.paginationDisabled = false;
              res.body.records.map(item => {
                item.checkedStatus = this.isCheked(item);
              });
            }
            let { records, current, size, total } = res.body;
            this.normalPersonList = records;
            this.searchForm.current = current;
            this.searchForm.size = size;
            this.total = total;
            this.loading = false;
          })
          .catch(res => {
            this.loading = false;
            this.$message.error(res);
          });
      } else {
        this.normalPersonList = [];
        // this.$message.warning('请输入关键字查询！');
        // this.initNormal()
      }
    },
    searchByKeyword() {
      this.isLatestPerson = false;
      this.searchForm.current = 1;
      this.searchPersonFun(this.searchPerson);
    },
    selectAllFun(val) {
      this.normalPersonList.map(item => {
        item.checkedStatus = val;
      });
      if (val) {
        this.$emit('selectAllPerFun', this.normalPersonList);
      } else {
        this.$emit('cancelAllPerFun', this.normalPersonList);
      }
    },
    clearAllPer() {
      this.$confirm('确定要清除常用联系人?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios
          .delete(
            '/uc/user/choice/empty/' + this.$store.state.user.userData.id
          )
          .then(res => {
            if (res.code == '0000') {
              this.$message({ type: 'success', message: '操作成功！' });
              this.normalPersonList = [];
              // this.initNormal()
            }
          });
      });
    },
    handleSizeChange(val) {
      this.searchForm.current = 1;
      this.searchForm.size = val;
      this.searchPersonFun(this.searchPerson);
    },
    // 查询最近使用人
    searchLatestPersonFun() {
      this.paginationDisabled = true;
      let userInfo = this.$store.state.user;
      let { userData: { id } } = userInfo;
      this.loading = true;
      this.$axios.get('/uc/user/choice/page', {
        userId: id,
        current: 1,
        size: 30
      }).then(res => {
        const { records, current, size, total } = res.body;
        this.isLatestPerson = true;
        this.searchForm.current = current;
        this.searchForm.size = size;
        this.total = total;
        this.loading = false;

        if (records.length !== 0) {
          res.body.records.map(item => {
            item.checkedStatus = this.isCheked(item);
          });
        }
        if (res.status) {
          this.normalPersonList = records;
        }
      }).catch(() => {
        this.loading = false;
      })
    },
    handleInput(val) {
      if (!val.length) {
        this.searchLatestPersonFun();
      }
    },
    changeSearchHandle() {
      if (!this.searchPerson.length) {
        this.searchLatestPersonFun();
      } else {
        this.searchByKeyword();
      }
    }
  },
  watch: {
    normalPersonList: {
      handler(newName, oldName) {
        let allTrue = true;
        this.normalPersonList.map(item => {
          if (!item.checkedStatus) {
            allTrue = false;
          }
        });
        if (allTrue && this.normalPersonList.length !== 0) {
          this.checkedAll = true;
        } else {
          this.checkedAll = false;
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.selectPersonBox {
  padding: 8px 32px;
  padding-bottom: 104px;

  .searchDiaBox {
    text-align: right;
  }

  .normalPerson {
    display: flex;
    flex-direction: column;
    height: 420px;
    margin-top: 8px;
    border: 1px solid rgba(205, 207, 212, 1);
    border-bottom: none;
    padding: 17px 32px;

    .clearNormal {
      float: right;
      color: #3aa27f;
      height: 14px;
      cursor: pointer;
    }

    .personSelect {
      padding: 20px 0px;
      height: calc(100% - 14px);
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      .normalPersons {
        flex: 1;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        .personCard {
          width: 32%;
          height: 32px;
          margin-bottom: 15px;
        }
      }
      .normalPersons:after {
        content: '';
        width: 32%;
      }
    }

    .person-page {
      text-align: right;
    }
  }

  .bloder {
    font-weight: bolder;
  }
}
</style>
